import React, { useEffect, useState } from "react";
import Tabs from "../../common/Tabs";
import TaskInfo from "./TaskInfo";
import ReminderHistory from "../../common/ReminderHistory";

const TaskInfoTabs = ({ task, defaultTab = "info" }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    setActiveTab(defaultTab);
  }, [defaultTab, task?.id]);

  return (
    <div>
      <Tabs
        tabs={[
          { key: "info", label: "Task Info" },
          { key: "reminders", label: "Reminder History" },
        ]}
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      {activeTab === "info" ? (
        <TaskInfo task={task} />
      ) : (
        <ReminderHistory triggerFor="tasks" triggerId={task?.id} />
      )}
    </div>
  );
};

export default TaskInfoTabs;
